'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Bug01Icon } from '@/components/ui/icon/glyphs';
import { onEvent } from '@/events';
import { useLayoutStore } from '@/stores/layout';
interface ReportErrorButtonProps {
  /** Error digest from the Next.js error boundary, attached to the report. */
  digest?: string | undefined;
  /** Telemetry surface (e.g. the component/page name). */
  surface?: string | undefined;
}

/**
 * "Report what broke" — opens the feedback modal in its bug/error variant with
 * the route + error digest prefilled. Used by the shared error boundary UI.
 */
export function ReportErrorButton(t0) {
  const $ = _c(9);
  const {
    digest,
    surface
  } = t0;
  const t = useTranslations("feedback");
  const openFeedback = useLayoutStore(_temp);
  let t1;
  if ($[0] !== digest || $[1] !== openFeedback || $[2] !== surface) {
    t1 = () => {
      const route = typeof window !== "undefined" ? window.location.pathname : undefined;
      onEvent("feedback_opened", {
        source: "error_boundary",
        intent: "bug"
      });
      openFeedback({
        intent: "bug",
        context: {
          surface: surface ?? "error_boundary",
          route,
          errorDigest: digest
        }
      });
    };
    $[0] = digest;
    $[1] = openFeedback;
    $[2] = surface;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("report_what_broke");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <AnimatedButton variant="secondary" prefix={Bug01Icon} onClick={t1}>{t2}</AnimatedButton>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp(s) {
  return s.openFeedback;
}